import React from "react";

import { SelectContractTypeButton } from "./SelectContractTypeButton";

import { ModalBody } from "./styles";

export function SelectContractTypeStep({ setStep }) {
	return (
		<ModalBody>
			<SelectContractTypeButton
				type="main"
				setStep={() => setStep("mainContract")}
			/>
			<SelectContractTypeButton
				type="reference"
				setStep={() => setStep("referenceContract")}
			/>
		</ModalBody>
	);
}
